import * as React from 'react';
import { UserCredits } from '../../interfaces/Credits/Credits';

export const UserCreditsContext = React.createContext<null|undefined|UserCredits>(null);
